import {Component, OnInit} from '@angular/core';
import {BaseDialog} from '../base-dialog';
import {NbDialogRef} from '@nebular/theme';
import {Router} from '@angular/router';
import {RetirementType} from '../../../class/lifeproject/retirement-type.enum';

@Component({
  selector: 'app-retirement-type-chooser-dialog',
  templateUrl: './retirement-type-chooser-dialog.component.html',
  styleUrls: ['./retirement-type-chooser-dialog.component.css']
})
export class RetirementTypeChooserDialogComponent extends BaseDialog<RetirementType> implements OnInit {
  type: RetirementType;

  constructor(dialogRef: NbDialogRef<RetirementType>, route: Router) {
    super(dialogRef, route);
  }

  setRetirementView(advanced: boolean) {
    this.type = advanced ? RetirementType.EPHESO : RetirementType.SIMPLE;

    this.close(this.type);
  }

  ngOnInit() {
  }

}
